export { fetchReport, fetchExport, fetchDetails, fetchDetailExport } from "../repo";

/** 默认统计月份使用北京时间，避免浏览器时区改变月界。 */
export function currentMonth(): string {
  return new Date().toLocaleDateString("sv-SE", { timeZone: "Asia/Shanghai" }).slice(0, 7);
}
